// @ts-nocheck
import React, { useEffect, useState } from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  required,
  useNotify,
  useRedirect,
  useRefresh,
  SaveButton,
  Toolbar,
  SelectInput,
  BooleanInput,
  useRecordContext,
  DateTimeInput,
  FormDataConsumer,
  DeleteWithConfirmButton,
  FunctionField,
  RaRecord,
  Button,
  FileInput,
  FileField,
  downloadCSV,
  AutocompleteArrayInput,
  useGetOne,
  AutocompleteInput,
  // NumberInput
} from "react-admin";
import { makeStyles } from "@mui/styles";
import {
  Autocomplete,
  Box,
  Grid,
  IconButton,
  Paper,
  Stack,
  TextField as MuiTextField,
  Typography,
  Button as MuiButton
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { dataProvider } from "../../../provider";
import Swal from "sweetalert2";
import moment from "moment";
import PostAddIcon from "@mui/icons-material/PostAdd";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import Papa from "papaparse";
import jsonExport from "jsonexport/dist";
import DescriptionIcon from "@mui/icons-material/Description";
import ReactJson from "react-json-view";
import { useFormContext } from "react-hook-form";
import Mbaas from "../../../provider/Mbaas";
import { isEmpty, omit, get } from "lodash";
import genRandomChar from "../../../utils/genRandomChar";
import InfoIcon from '@mui/icons-material/Info';
import withReactContent from "sweetalert2-react-content";

const today = moment().toISOString();

const useStyles = makeStyles({
  input: {
    marginBottom: "-20px",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
  },
  test: {
    '& ul li[aria-selected="true"]:after': {
      content: "'\\2713'",
      marginLeft: "auto",
    },
  },
});

const ToolbarEdit = () => {
  const record = useRecordContext();
  let disabled = false;
  if (record.start < today) disabled = true;
  return (
    <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
      <SaveButton alwaysEnable />
      <DeleteWithConfirmButton
        redirect={`/promotions/flashsale`}
        disabled={disabled}
      />
    </Toolbar>
  );
};

const ToolbarCsvDialog = () => {
  return <></>;
};

const AutocompleteUrlInput = ({ record }) => {
  const [urlOption, setUrlOption] = useState([]);

  const { watch, resetField, getFieldState, setValue } = useFormContext();

  const selectedPlatform = watch("platforms") || record.configs.platform;
  const selectedCountry = watch("country");
  const urlOptionWatch = watch("bonus.url");
  const selectedPlatformFieldState = getFieldState("platforms");
  useEffect(() => {
    const getUrlList = async () => {
      if (isEmpty(record.country) && isEmpty(record.configs.platform)) {
        setUrlOption([]);
        return;
      }
      const resp = await Mbaas.client.invokeApi("console-webview-link-list", {
        country: selectedCountry,
        platform: selectedPlatform,
      });
      if (resp.data) {
        setUrlOption(resp.data.map((m) => ({ id: m.url, name: m.label })));
      } else {
        setUrlOption([]);
      }
    };
    getUrlList();
  }, [selectedCountry, selectedPlatform]);

  useEffect(() => {
    resetField("bonus.url", {
      keepDirty: true,
      keepError: true,
      keepTouched: true,
      defaultValue: "",
    });
  }, [
    selectedPlatform,
    selectedCountry,
    selectedPlatformFieldState?.isTouched,
    record.items.bonus.url,
    record.configs.platform,
    resetField,
    setValue,
  ]);

  useEffect(() => {
    if (urlOptionWatch) {
      setValue("bonus.url", urlOptionWatch, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    }
  }, [urlOptionWatch, setValue]);

  return (
    <AutocompleteInput
      label="Url"
      source="bonus.url"
      fullWidth
      choices={urlOption}
      defaultValue={record?.items?.bonus?.url}
      disabled={record.start < today}
      validate={required()}
    />
  );
};

export const EditFlashsale = ({ onCancel, id, ...props }) => {
  const classes = useStyles();

  const [optionItemGroup, setOptionItemGroup] = useState([]);
  const [optionItemKey, setOptionItemKey] = useState([]);

  const [selectedItemGroup, setSelectedItemGroup] = useState([]);
  const [selectedItemKey, setSelectedItemKey] = useState([]);

  const [optionTargetItemGroup, setOptionTargetItemGroup] = useState([]);
  const [optionTargetItemKey, setOptionTargetItemKey] = useState([]);

  const [selectedTargetItemGroup, setSelectedTargetItemGroup] = useState([]);
  const [selectedTargetItemKey, setSelectedTargetItemKey] = useState([]);

  const [firstRender, setFirstRender] = useState(true);

  const [specSubSx, setSpecSubSx] = useState(12);

  const [openCsvDialog, setOpenCsvDialog] = useState(false);
  const [fileCsv, setFileCsv] = useState("");
  const [uploadedFileCsv, setUploadedFileCsv] = useState("");
  const [specificSubscriber, setSpecificSubscriber] = useState([]);

  const { data, isLoading } = useGetOne(
    "promotionsFlashsale",
    { id: id },
    { enabled: !!id }
  );

  const [isNewSubs, setIsNewSubs] = useState(
    data?.configs.new_subscriber_only || false
  );
  const [isComebackSubs, setIsComebackSubs] = useState(
    data?.configs.comeback_subscriber || false
  );
  const [isBirthdaySubs, setIsBirthdaySubs] = useState(
    data?.configs.birthday_subscriber || false
  );
  const [isProductiveSubs, setIsProductiveSubs] = useState(
    data?.configs.ever_productive_subscriber || false
  );
  const [isCashback, setIsCashback] = useState(
    (data?.configs?.cashback?.status &&
      data?.configs?.cashback?.status !== undefined) ||
    false
  );
  const [isBonus, setIsBonus] = useState(
    data?.items?.bonus?.code !== "" &&
    data?.items?.bonus?.code !== undefined
  );
  const [autoBonus, setAutoBonus] = useState(
    data?.items?.bonus?.auto_bonus || false
  );
  const [bonusCode, setBonusCode] = useState(data?.items?.bonus?.code || "");
  const [promoCode, setPromoCode] = useState(
    data?.configs?.promo_code?.code || ""
  );
  const [selectedPlatform, setSelectedPlatform] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");

  const [showItemGroupError, setShowItemGroupError] = useState(false);
  const [showItemKeyError, setShowItemKeyError] = useState(false);
  const [showTargetItemGroupError, setShowTargetItemGroupError] = useState(false);
  const [showTargetItemKeyError, setShowTargetItemKeyError] = useState(false);
  const [showBonusCodeError, setShowBonusCodeError] = useState(false);
  const [showPromoCodeError, setShowPromoCodeError] = useState(false);

  const notify = useNotify();

  const handleCloseCsvDialog = () => {
    setOpenCsvDialog(false);
  };

  const handleOpenCsvDialog = () => {
    setOpenCsvDialog(true);
  };

  const handleGenerateRandomCode = ({
    field,
  }: {
    field: "BONUS_CODE" | "PROMO_CODE";
  }) => {
    const generatedCode = genRandomChar(10).toUpperCase();
    if (field === "PROMO_CODE") setPromoCode(generatedCode);
    if (field === "BONUS_CODE") setBonusCode(generatedCode);
  };

  const handleUploadCsv = () => {
    const reader = new FileReader();
    reader.onload = async ({ target }) => {
      const csv = Papa.parse(target.result, { header: true });
      const parsedData = csv?.data;
      const columns = parsedData
        .flat()
        .map((item) => item.phone)
        .filter((item) => item);
      if (!columns.length) {
        notify(`1st line in CSV file should be 'phone'!`, { type: "warning" });
        return;
      }
      setSpecificSubscriber(columns);
      setFileCsv(null);
      notify(`CSV file uploaded successfully!`);
    };
    reader.readAsText(fileCsv);
  };

  const uploadedCsv = async () => {
    let filename = `spec-subs-phone`;
    if (uploadedFileCsv !== "") filename = uploadedFileCsv;
    let jsonObject = [{ phone: "" }];
    if (specificSubscriber?.length) {
      jsonObject = specificSubscriber.map((phone) => {
        return { phone: phone };
      });
    }
    jsonExport(jsonObject, {}, (err: any, csv: any) => {
      downloadCSV(csv, filename);
    });
  };

  if (!isLoading) {
    data["is_bonus"] = data?.items?.bonus?.code !== "" && data?.items?.bonus?.code !== undefined;
  }

  useEffect(() => {
    let haloTimeout = setTimeout(() => {
      dataProvider
        .getList("servicesProduct", {
          filter: {},
          pagination: { page: 1, perPage: 1000 },
          sort: {
            field: "label",
            order: "ASC",
          },
        })
        .then((v) => {
          const items = v.data;
          const itemGroups = [...new Set(items)]
            ?.filter(
              (v, i, a) =>
                a.findIndex((t) => t.item_group === v.item_group) === i
            )
            .filter(
              (x) => !["bpjs", "plnbill"].includes(x.item_group.toLowerCase())
            )
            .map((v) => ({
              id: v.item_group,
              name: v.item_group,
            }))
            .sort((a, b) => {
              const nameA = a.name.toUpperCase();
              const nameB = b.name.toUpperCase();
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;
            });
          const itemKeys = [...new Set(items)]
            .filter((u) =>
              selectedItemGroup.map((t) => t.id).includes(u.item_group)
            )
            .map((v) => ({
              id: `${v.item_key} (${v.label})`,
              name: `${v.item_key} (${v.label})`,
            }));
          setOptionItemGroup(itemGroups);
          setOptionItemKey(itemKeys);
          !firstRender && setSelectedItemKey(itemKeys);
        });
    }, 2000);

    return () => clearTimeout(haloTimeout);
  }, [id, firstRender, selectedItemGroup]);

  useEffect(() => {
    let haloTimeout = setTimeout(() => {
      dataProvider
        .getList("servicesProduct", {
          filter: {},
          pagination: { page: 1, perPage: 1000 },
          sort: {
            field: "label",
            order: "ASC",
          },
        })
        .then((v) => {
          const items = v.data;
          const itemGroups = [...new Set(items)]
            ?.filter(
              (v, i, a) =>
                a.findIndex((t) => t.item_group === v.item_group) === i
            )
            .filter(
              (x) => !["bpjs", "plnbill"].includes(x.item_group.toLowerCase())
            )
            .map((v) => ({
              id: v.item_group,
              name: v.item_group,
            }))
            .sort((a, b) => {
              const nameA = a.name.toUpperCase();
              const nameB = b.name.toUpperCase();
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;
            });
          const itemKeys = [...new Set(items)]
            .filter((u) =>
              selectedTargetItemGroup.map((t) => t.id).includes(u.item_group)
            )
            .map((v) => ({
              id: `${v.item_key} (${v.label})`,
              name: `${v.item_key} (${v.label})`,
            }));
          setOptionTargetItemGroup(itemGroups);
          setOptionTargetItemKey(itemKeys);
          !firstRender && setSelectedTargetItemKey(itemKeys);
        });
    }, 2000);

    return () => clearTimeout(haloTimeout);
  }, [id, firstRender, selectedTargetItemGroup]);

  useEffect(() => {
    const close = (e) => {
      if (e.keyCode === 27) {
        onCancel();
      }
    };
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, [onCancel]);

  const handleNotFound = () => {
    Swal.fire("Subscriber Not Found", "", "error");
  };

  const redirect = useRedirect();
  const refresh = useRefresh();

  const onSubmitHandler = async (dataSubmit) => {
    let configsSpecSubs = [] as Array<{
      id: string;
      name: string;
      phone: string;
    }>;

    if (
      dataSubmit.configs.specific_subscriber.status === true &&
      specificSubscriber?.length
    ) {
      const getSubs = await dataProvider.getList("subscribers", {
        filter: {
          phone: specificSubscriber,
        },
        sort: {
          field: "phone",
          order: "asc",
        },
        pagination: {
          page: 1,
          perPage: 999999,
        },
      });
      configsSpecSubs = getSubs.data.map((subs) => {
        return { id: subs.id, name: subs.name, phone: subs.phone };
      });
      if (
        !configsSpecSubs.length ||
        specificSubscriber.length !== configsSpecSubs.length
      ) {
        return handleNotFound();
      }
    }

    if (
      dataSubmit.configs.specific_subscriber.status === true &&
      !specificSubscriber?.length
    ) {
      dataSubmit.configs.specific_subscriber.status = false;
    }

    // Validate cashback amount/percentage against promotion value
    if (dataSubmit.cashback.status) {
      const promotionValue = Number(dataSubmit.value);
      if (Number.isNaN(promotionValue) || promotionValue <= 0) {
        Swal.fire(
          "Invalid Promotion Value",
          "Please enter a valid promotion value",
          "error"
        );
        return;
      }
      if (dataSubmit.cashback.type === "PERCENTAGE") {
        const cashbackPercentage = Number(dataSubmit.cashback.percentage);
        // For percentage, validate it's between 0 and 1 (e.g., 0.07 for 7%, 0.5 for 50%)
        if (cashbackPercentage < 0 || cashbackPercentage > 1) {
          Swal.fire(
            "Invalid Cashback",
            "Cashback percentage must be between 0 and 1 (e.g., 0.07 for 7%, 0.5 for 50%)",
            "error"
          );
          return;
        }
      } else if (dataSubmit.cashback.type === "WHOLE") {
        const cashbackAmount = Number(dataSubmit.cashback.amount);
        if (cashbackAmount > promotionValue) {
          Swal.fire(
            "Invalid Cashback",
            "Cashback amount must be less than or equal to the promotion value",
            "error"
          );
          return;
        }
      }
    }

    const { platforms, ...otherData } = dataSubmit;
    let submitData;

    if (data.start < today) {
      submitData = {
        start: dataSubmit.start,
        end: dataSubmit.end,
      };
    } else {
      submitData = {
        ...omit(otherData, ["bonus", "is_bonus", "cashback", "promo_code"]),
        value: Number(dataSubmit.value),
        configs: {
          ...{
            ...dataSubmit.configs,
            ever_productive_subscriber: isProductiveSubs,
            new_subscriber_only: isNewSubs,
            comeback_subscriber: isComebackSubs,
            birthday_subscriber: isBirthdaySubs,
            cashback: {
              status:
                (dataSubmit.cashback.percentage || dataSubmit.cashback.amount) && dataSubmit.cashback.unit
                  ? dataSubmit.cashback.status
                  : false,
              percentage: dataSubmit.cashback.percentage
                ? `${dataSubmit.cashback.percentage}`
                : "",
              amount: dataSubmit.cashback.amount ? dataSubmit.cashback.amount : "",
              unit: dataSubmit.cashback.unit || "",
            },
            promo_code: {
              status: data.configs?.promo_code?.status || false,
              ...(promoCode ? { code: promoCode } : { code: "" }),
            },
          },
          platform: platforms,
          specific_subscriber: {
            status: dataSubmit.configs.specific_subscriber.status,
            ...(configsSpecSubs.length ? { subscribers: configsSpecSubs } : {}),
          },
        },
        items: {
          item_groups: selectedItemGroup.map((x) => {
            return x.id;
          }),
          item_keys: selectedItemKey.map((x) => {
            return x.id.split(" (")[0];
          }),
          bonus: {
            item_groups: selectedTargetItemGroup.map((x) => {
              return x.id;
            }),
            item_keys: selectedTargetItemKey.map((x) => {
              return x.id.split(" (")[0];
            }),
            product_name: dataSubmit.bonus?.product_name || "",
            code: dataSubmit.is_bonus ? dataSubmit.items?.bonus?.auto_bonus ? "AUTO" : bonusCode || "" : "",
            url: dataSubmit.bonus?.url || "",
            auto_bonus: dataSubmit.items?.bonus?.auto_bonus || false,
            usage: dataSubmit.items?.bonus?.usage || [],
          },
        },
      };
    }

    const isFieldEmpty = (str) => {
      return !str || str.trim() === '';
    };
    
    if (selectedItemGroup.length === 0) {
      notify("Item Groups is required", { type: "warning" });
      setShowItemGroupError(true);
      return;
    } else {
      setShowItemGroupError(false);
    }
    
    if (selectedItemKey.length === 0) {
      notify("Item Keys is required", { type: "warning" });
      setShowItemKeyError(true);
      return;
    } else {
      setShowItemKeyError(false);
    }

    if (data.is_bonus && !data.bonus?.auto_bonus) {
      if (selectedTargetItemGroup.length === 0) {
        notify("Target Item Groups is required", { type: "warning" });
        setShowTargetItemGroupError(true);
        return;
      } else {
        setShowTargetItemGroupError(false);
      }
      
      if (selectedTargetItemKey.length === 0) {
        notify("Target Item Keys is required", { type: "warning" });
        setShowTargetItemKeyError(true);
        return;
      } else {
        setShowTargetItemKeyError(false);
      }
    
      if (isFieldEmpty(bonusCode)) {
        notify("Bonus Code is required and cannot be empty", { type: "warning" });
        setShowBonusCodeError(true);
        return;
      } else {
        setShowBonusCodeError(false);
      }
    }

    if (data.promo_code?.status) {
      if (isFieldEmpty(promoCode)) {
        notify("Promo Code is required and cannot be empty", { type: "warning" });
        setShowPromoCodeError(true);
        return;
      } else {
        setShowPromoCodeError(false);
      }
    }

    await dataProvider
      .update("promotionsFlashsale", {
        data: submitData,
        id,
      })
      .then(() => {
        notify("ra.notification.created", {
          type: "info",
          messageArgs: { smart_count: 1 },
          undoable: true,
        });
        redirect(`/promotions/flashsale`);
        refresh();
        Swal.fire("Success!", "", "success");
      });
  };

  return (
    <Edit
      resource="promotionsFlashsale"
      title=" &rsaquo; Edit"
      {...props}
      component="div"
    >
      <Box pt={5} width={{ xs: "100vW", sm: 600 }} mt={{ xs: 2, sm: 1 }}>
        <Stack
          direction="row"
          p={0}
          sx={{ position: "absolute", right: 0, top: 10, zIndex: 100 }}
        >
          <IconButton onClick={onCancel} size="small">
            <CloseIcon />
          </IconButton>
        </Stack>
        <SimpleForm
          // sx={{ width: "100%" }}
          onSubmit={onSubmitHandler}
          toolbar={<ToolbarEdit />}
        >
          <div className={classes.root}>
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <FunctionField
                  render={(record: RaRecord) => (
                    <SelectInput
                      label="Country"
                      source="country"
                      fullWidth
                      validate={required()}
                      choices={[
                        { id: "HK", name: "Hongkong" },
                        { id: "ID", name: "Indonesia" },
                        { id: "TW", name: "Taiwan" },
                        { id: "MY", name: "Malaysia" },
                      ]}
                      value={selectedCountry}
                      onChange={(e) => {
                        setSelectedCountry(e.target.value);
                      }}
                      data-testid="input-country"
                      disabled={record.start < today}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6}>
                <FunctionField
                  render={(record: RaRecord) => {
                    if (typeof record.configs.platform === "string") {
                      return (
                        <AutocompleteArrayInput
                          label="Platform"
                          source="platforms"
                          defaultValue={[record.configs.platform]}
                          fullWidth
                          validate={required()}
                          value={selectedPlatform}
                          onChange={(value) => {
                            setSelectedPlatform(value);
                          }}
                          choices={[
                            { id: "M21", name: "M21" },
                            { id: "G2", name: "G2" },
                            { id: "GHK", name: "GHK" },
                          ]}
                          data-testid="input-platform"
                          disabled={record.start < today}
                        />
                      );
                    }
                    return (
                      <AutocompleteArrayInput
                        label="Platform"
                        source="platforms"
                        defaultValue={record.configs.platform}
                        fullWidth
                        validate={required()}
                        choices={[
                          { id: "M21", name: "M21" },
                          { id: "G2", name: "G2" },
                          { id: "GHK", name: "GHK" },
                        ]}
                        data-testid="input-platform"
                        disabled={record.start < today}
                        onChange={(value) => {
                          if (!value.includes("GHK")) {
                            setIsBirthdaySubs(false);
                          }
                        }}
                      />
                    );
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <ItemGroupAutocomplete
                  label="Item Groups"
                  source="items.item_groups"
                  validate={required()}
                  option={optionItemGroup}
                  selectedItemGroup={selectedItemGroup}
                  setSelectedItemGroup={setSelectedItemGroup}
                  setSelectedTargetItemGroup={setSelectedTargetItemGroup}
                  autoBonus={autoBonus}
                  setSelectedItemKey={setSelectedItemKey}
                  firstRender={firstRender}
                  setFirstRender={setFirstRender}
                  today={today}
                  error={showItemGroupError}
                  helperText={showItemGroupError ? "Item Groups is required" : ""}
                />
              </Grid>
              <Grid item xs={12}>
                <ItemKeyAutocomplete
                  label="Item Keys"
                  source="items.item_keys"
                  validate={required()}
                  option={optionItemKey}
                  selectedItemKey={selectedItemKey}
                  setSelectedItemKey={setSelectedItemKey}
                  firstRender={firstRender}
                  setFirstRender={setFirstRender}
                  today={today}
                  error={showItemKeyError}
                  helperText={showItemKeyError ? "Item Keys is required" : ""}
                />
              </Grid>
              <Grid item sm={12}>
                <Box sx={{ display: "flex" }}>
                  <h5>Promotion Features Descriptions</h5>
                  <MuiButton onClick={() => alertInformation("PROMOTION_FEATURES")} style={{ minWidth: 'auto', padding: 0, marginLeft: "10px" }}>
                    <InfoIcon />
                  </MuiButton>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <FunctionField
                  render={(record: RaRecord) => (
                    <BooleanInput
                      fullWidth
                      source="configs.promo_code.status"
                      data-testid="promo_code"
                      label="Add Promo Code?"
                      disabled={record.start < today}
                      helperText={false}
                    />
                  )}
                />
              </Grid>
              {promoCode && (
                <>
                  <Grid item xs={8} style={{ paddingTop: 0 }}>
                    <FunctionField
                      render={(record: RaRecord) => (
                        <MuiTextField
                          fullWidth
                          value={promoCode}
                          label="Promo Code"
                          defaultValue={promoCode}
                          onChange={(e) => setPromoCode(e.target.value)}
                          disabled={record.start < today}
                          error={showPromoCodeError}
                          helperText={showPromoCodeError ? "Promo Code is required" : ""}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={4} style={{ paddingTop: 0 }}>
                    <FunctionField
                      sx={{ padding: "0.5rem", width: "100%", height: "100%" }}
                      render={(record: RaRecord) => (
                        <Button
                          onClick={() =>
                            handleGenerateRandomCode({ field: "PROMO_CODE" })
                          }
                          label="Generate"
                          sx={{
                            width: "75%",
                            height: "75%",
                            alignContent: "center",
                            color: "white",
                            backgroundColor: "#0488d1",
                            margin: "8px 0px 3px 0px",
                            padding: "0px 10px 0px 10px",
                            ":hover": {
                              color: "white",
                              backgroundColor: "#0488d1",
                            },
                            ":disabled": {
                              color: "gray",
                              backgroundColor: "#c0c0c0",
                            },
                          }}
                          disabled={record.start < today}
                        />
                      )}
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={12}>
                <FunctionField
                  render={(record: RaRecord) => (
                    <BooleanInput
                      fullWidth
                      source="is_bonus"
                      data-testid="is_bonus"
                      label="Add Bonus?"
                      onChange={(e) => setIsBonus(e.target.checked)}
                      disabled={record.start < today}
                    />
                  )}
                />
              </Grid>
              {isBonus && (
                <>
                  <Grid item xs={12}>
                    <FunctionField
                      render={(record: RaRecord) => (
                        <BooleanInput
                          fullWidth
                          source="items.bonus.auto_bonus"
                          label="Auto Bonus?"
                          onChange={(e) => {
                            setAutoBonus(e.target.checked)
                            setBonusCode("")
                            if (e.target.checked) {
                              setSelectedTargetItemGroup(selectedItemGroup);
                            }
                          }}
                          disabled={record.start < today}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="h5">
                      {autoBonus ? "Auto Bonus Item" : "Bonus Item"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <ItemTargetGroupAutocomplete
                      label="Target Item Groups"
                      source="items.bonus.item_groups"
                      validate={required()}
                      option={optionTargetItemGroup}
                      selectedTargetItemGroup={selectedTargetItemGroup}
                      setSelectedTargetItemGroup={setSelectedTargetItemGroup}
                      selectedItemGroup={selectedItemGroup}
                      disabled={autoBonus}
                      setAutoBonus={setAutoBonus}
                      setSelectedTargetItemKey={setSelectedTargetItemKey}
                      firstRender={firstRender}
                      setFirstRender={setFirstRender}
                      today={today}
                      error={showTargetItemGroupError}
                      helperText={showTargetItemGroupError ? "Target Item Groups is required" : ""}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <ItemTargetKeyAutocomplete
                      label="Target Item Keys"
                      source="items.bonus.item_keys"
                      validate={required()}
                      option={optionTargetItemKey}
                      selectedTargetItemKey={selectedTargetItemKey}
                      setSelectedTargetItemKey={setSelectedTargetItemKey}
                      firstRender={firstRender}
                      setFirstRender={setFirstRender}
                      today={today}
                      data-testid="input-bonus-item-keys"
                      error={showTargetItemKeyError}
                      helperText={showTargetItemKeyError ? "Target Item Keys is required" : ""}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FunctionField
                      render={(record: RaRecord) => (
                        <TextInput
                          fullWidth
                          className={classes.input}
                          source="bonus.product_name"
                          defaultValue={record?.items?.bonus?.product_name}
                          data-testid="input-bonus-product-name"
                          label="Product Name"
                          disabled={record.start < today}
                          validate={required()}
                        />
                      )}
                    />
                  </Grid>
                  {!autoBonus && (
                    <>
                      <Grid item xs={8}>
                        <FunctionField
                          render={(record: RaRecord) => (
                            <BonusCodeInput
                              source="bonus.code"
                              value={bonusCode}
                              setBonusCode={setBonusCode}
                              disabled={record.start < today}
                              error={showBonusCodeError}
                              helperText={showBonusCodeError ? "Bonus Code is required" : ""}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={4} sx={{ display: "flex" }}>
                        <FunctionField
                          sx={{
                            alignContent: "center",
                          }}
                          render={(record: RaRecord) => (
                            <Button
                              sx={{
                                color: "white",
                                backgroundColor: "#0488d1",
                                margin: "8px 0px 3px 0px",
                                padding: "15px 10px 15px 10px",
                                ":hover": {
                                  color: "white",
                                  backgroundColor: "#0488d1",
                                },
                              }}
                              onClick={() =>
                                handleGenerateRandomCode({
                                  field: "BONUS_CODE",
                                })
                              }
                              label="Generate"
                              disabled={record.start < today}
                            />
                          )}
                        />
                      </Grid>
                    </>
                  )}
                  <Grid item xs={12}>
                    <FunctionField
                      render={(record: RaRecord) => (
                        <AutocompleteUrlInput record={record} />
                      )}
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={12}>
                <FunctionField
                  render={(record: RaRecord) => (
                    <BooleanInput
                      fullWidth
                      source="cashback.status"
                      label="Add Cashback?"
                      disabled={record.start < today}
                      defaultValue={isCashback}
                      onChange={(e) => setIsCashback(e.target.checked)}
                    />
                  )}
                />
              </Grid>
              {isCashback && (
                <>
                  <Grid item xs={12}>
                    <Typography variant="h5">Cashback Item</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <FunctionField
                      render={(record: RaRecord) => {
                        console.log(532141, 'record', record)
                        return (
                          <SelectInput
                            label="Type"
                            source="cashback.type"
                            fullWidth
                            defaultValue={
                              record?.configs?.cashback?.percentage ? "PERCENTAGE" : "WHOLE"
                            }
                            choices={[
                              { id: "WHOLE", name: "Whole amount" },
                              { id: "PERCENTAGE", name: "Percentage" },
                            ]}
                            validate={required()}
                            disabled={record.start < today}
                          />
                        );
                      }}
                    />
                  </Grid>
                  <FormDataConsumer>
                    {({ formData }) => {
                      return (
                        <Grid item xs={6}>
                          <FunctionField
                            render={(record: RaRecord) => {
                              const cashBackType = formData?.cashback?.type || 
                                (record?.configs?.cashback?.percentage ? "PERCENTAGE" : "WHOLE");
                              const cashBackLabel =
                                cashBackType === "PERCENTAGE"
                                  ? "Percentage (example: 0.5)"
                                  : "Type whole amount for cashback";
                              
                              return (
                                <TextInput
                                  fullWidth
                                  className={classes.input}
                                  source={
                                    cashBackType === "PERCENTAGE"
                                      ? "cashback.percentage"
                                      : "cashback.amount"
                                  }
                                  defaultValue={
                                    cashBackType === "PERCENTAGE"
                                      ? record?.configs?.cashback?.percentage || ""
                                      : record?.configs?.cashback?.amount || ""
                                  }
                                  label={cashBackLabel}
                                  inputProps={{ pattern: String.raw`^[0-9]*(\.[0-9]*)?$` }}
                                  disabled={record.start < today}
                                  validate={required()}
                                />
                              );
                            }}
                          />
                        </Grid>
                      );
                    }}
                  </FormDataConsumer>
                  <Grid item xs={6}>
                    <FunctionField
                      render={(record: RaRecord) => (
                        <SelectInput
                          label="Unit"
                          source="cashback.unit"
                          fullWidth
                          defaultValue={record?.configs?.cashback?.unit || ""}
                          choices={[
                            { id: "COIN", name: "Coin ( Balance )" },
                            { id: "POINT", name: "Point" },
                          ]}
                          disabled={record.start < today}
                          validate={required()}
                        />
                      )}
                    />
                  </Grid>
                </>
              )}
              <Grid item sm={12}>
                <Box sx={{ display: "flex" }}>
                  <h5>Target Promotion Options</h5>
                  <MuiButton onClick={() => alertInformation("TARGET_PROMOTION")} style={{ minWidth: 'auto', padding: 0, marginLeft: "10px" }}>
                    <InfoIcon />
                  </MuiButton>
                </Box>
              </Grid>
              <FormDataConsumer>
                {({ formData }) => {                
                  const platformArray = get(formData, "platforms", []);
                  const isPlatformGHK = platformArray.length === 1 && platformArray[0] === "GHK";
              
                  if (isPlatformGHK) {
                    return (
                      <Grid item xs={6}>
                        <BooleanInput
                          source="configs.birthday_subscriber"
                          label="Birthday Subs"
                          data-testid="input-birthday-subs"
                          disabled={formData.start < today}
                          checked={isBirthdaySubs}
                          onChange={(e) => {
                            setIsBirthdaySubs(e.target.checked);
                          }}
                        />
                      </Grid>
                    );
                  }
                  return null;
                }}
              </FormDataConsumer>
              <Grid item xs={6}>
                <FunctionField
                  render={(record: RaRecord) => (
                    <BooleanInput
                      source="configs.once_per_target"
                      label="1x / MSISDN?"
                      disabled={record.start < today}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6}>
                <FunctionField
                  render={(record: RaRecord) => (
                    <BooleanInput
                      source="configs.new_subscriber_only"
                      label="For New Subs. Only?"
                      title="Subs. / MSISN without success transactions before this promo is created"
                      data-testid="input-new-subscriber-only"
                      disabled={record.start < today}
                      checked={isNewSubs}
                      onChange={(event) => {
                        setIsNewSubs(event.target.checked);
                        setIsProductiveSubs(false);
                        setIsComebackSubs(false);
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={specSubSx}>
                <FunctionField
                  render={(record: RaRecord) => (
                    <BooleanInput
                      source="configs.specific_subscriber.status"
                      label="For Specific Subs.?"
                      title="Is applied for Specific Subs.?"
                      disabled={record.start < today}
                    />
                  )}
                />
              </Grid>
              <FormDataConsumer subscription={{ values: true }}>
                {({ formData, ...rest }) => {
                  if (formData.configs.specific_subscriber.status) {
                    setSpecSubSx(6);
                    if (specificSubscriber?.length === 0) {
                      setSpecificSubscriber(
                        formData.configs.specific_subscriber?.subscribers?.map(
                          (subs) => subs.phone
                        )
                      );
                    }
                    return (
                      <Grid item xs={6}>
                        <Button
                          label="CSV File"
                          data-testid="csv-file"
                          variant="contained"
                          onClick={handleOpenCsvDialog}
                        >
                          <PostAddIcon />
                        </Button>
                        <SpecSubCsvFile
                          openCsvDialog={openCsvDialog}
                          handleCloseCsvDialog={handleCloseCsvDialog}
                          uploadedCsv={uploadedCsv}
                          setUploadedFileCsv={setUploadedFileCsv}
                          specificSubscriber={specificSubscriber}
                          handleUploadCsv={handleUploadCsv}
                          fileCsv={fileCsv}
                          setFileCsv={setFileCsv}
                          today={today}
                        />
                      </Grid>
                    );
                  } else {
                    setSpecSubSx(12);
                  }
                }}
              </FormDataConsumer>

              <Grid item xs={6}>
                <FunctionField
                  render={(record: RaRecord) => (
                    <BooleanInput
                      source="configs.ever_productive_subscriber"
                      label="For Ever Productive Subs. ?"
                      title="Subs. who have done their first purchase"
                      data-testid="input-ever-productive-subscriber"
                      disabled={record.start < today}
                      checked={isProductiveSubs}
                      onChange={(event) => {
                        setIsProductiveSubs(event.target.checked);
                        setIsNewSubs(false);
                      }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6}>
                <FunctionField
                  render={(record: RaRecord) => (
                    <BooleanInput
                      source="configs.registered_subscriber"
                      label="For Registered Subs. ?"
                      title="Subs. who has registered"
                      data-testid="input-registered-subscriber"
                      disabled={record.start < today}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <FunctionField
                  render={(record: RaRecord) => (
                    <BooleanInput
                      source="configs.comeback_subscriber"
                      label="For Comeback Subs. ?"
                      title="Subs. who has not purchase more than 30 days"
                      data-testid="input-comeback-subscriber"
                      checked={isComebackSubs}
                      onChange={(e) => {
                        setIsComebackSubs(e.target.checked);
                        setIsNewSubs(false);
                      }}
                      disabled={record.start < today}
                    />
                  )}
                />
              </Grid>
              <Grid item sm={12}>
                <Box sx={{ display: "flex" }}>
                  <h5>Promotion Usage</h5>
                  <MuiButton onClick={() => alertInformation("PROMOTION_USAGE")} style={{ minWidth: 'auto', padding: 0, marginLeft: "10px" }}>
                    <InfoIcon />
                  </MuiButton>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <FunctionField
                  render={(record: RaRecord) => (
                    <TextInput
                      fullWidth
                      className={classes.input}
                      source="configs.max_usage_per_subscriber"
                      data-testid="max_usage_per_subscriber"
                      label="Max Usage per Subs."
                      validate={required()}
                      disabled={record.start < today}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6}>
                <FunctionField
                  render={(record: RaRecord) => (
                    <TextInput
                      fullWidth
                      className={classes.input}
                      source="configs.total_usage"
                      data-testid="total_usage"
                      label="Max Total Usage"
                      validate={required()}
                      disabled={record.start < today}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <FunctionField
                  render={(record: RaRecord) => (
                    <TextInput
                      fullWidth
                      className={classes.input}
                      source="value"
                      data-testid="value"
                      label="Value"
                      validate={required()}
                      disabled={record.start < today}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={6}>
                <DateTimeInput
                  label="Valid From"
                  source="start"
                  fullWidth
                  className={classes.input}
                  validate={[required()]}
                />
              </Grid>
              <Grid item xs={6}>
                <DateTimeInput
                  label="Valid Until"
                  source="end"
                  fullWidth
                  className={classes.input}
                  validate={[required()]}
                />
              </Grid>
            </Grid>
          </div>
        </SimpleForm>
      </Box>
    </Edit>
  );
};

const ItemGroupAutocomplete = ({ setSelectedItemGroup, today, error, helperText, ...props }) => {
  const classes = useStyles();

  const { setValue } = useFormContext();

  const record = useRecordContext();

  useEffect(() => {
    const tes = record.items.item_groups
      ?.map((v) => ({
        id: v,
        name: v,
      }))
      .sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    setSelectedItemGroup(tes);
  }, [setSelectedItemGroup, record.items.item_groups]);

  return (
    <Autocomplete
      fullWidth
      multiple
      id="tags-standard"
      disableCloseOnSelect={true}
      options={props.option}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      value={props.selectedItemGroup}
      style={{ marginBottom: "32px" }}
      onChange={(_, v) => {
        // onChange(v)
        props.setFirstRender(false);
        setSelectedItemGroup(v);
        props.setSelectedItemKey([]);
        setValue(`configs.dirty`, true, { shouldDirty: true });
        if(props.autoBonus) {
          props.setSelectedTargetItemGroup(v);
        }
      }}
      required={props.validate.isRequired}
      PaperComponent={({ children }) => (
        <Paper className={classes.test}>{children}</Paper>
      )}
      disabled={record.start < today}
      renderInput={(params) => (
        <MuiTextField
          {...params}
          variant="filled"
          label={props.label}
          placeholder={`select Item Group`}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

const ItemKeyAutocomplete = ({ setSelectedItemKey, today, error, helperText, ...props }) => {
  const classes = useStyles();

  const { setValue } = useFormContext();

  const record = useRecordContext();

  useEffect(() => {
    const tes = record.items.item_keys?.map((v) => ({
      id: v,
      name: v,
    }));
    setSelectedItemKey(tes);
  }, [setSelectedItemKey, record.items.item_keys]);

  return (
    <Autocomplete
      fullWidth
      multiple
      id="tags-standard"
      disableCloseOnSelect={true}
      options={props.option}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      value={props.selectedItemKey}
      style={{ marginBottom: "32px" }}
      onChange={(_, v) => {
        // onChange(v)
        setSelectedItemKey(v);
        setValue(`configs.dirty`, true, { shouldDirty: true });
      }}
      required={props.validate.isRequired}
      PaperComponent={({ children }) => (
        <Paper className={classes.test}>{children}</Paper>
      )}
      disabled={record.start < today}
      renderInput={(params) => (
        <MuiTextField
          {...params}
          variant="filled"
          label={props.label}
          placeholder={`select Item Key`}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

const BonusCodeInput = ({ setBonusCode, disabled, error, helperText, ...props }) => {
  return (
    <MuiTextField
      fullWidth
      value={props.value}
      label="Bonus Code"
      defaultValue={props.value}
      onChange={(e) => setBonusCode(e.target.value)}
      disabled={disabled}
      error={error}
      helperText={helperText}
    />
  );
};

const ItemTargetGroupAutocomplete = ({
  setSelectedTargetItemGroup,
  today,
  error,
  helperText,
  ...props
}) => {
  const classes = useStyles();

  const { setValue } = useFormContext();

  const record = useRecordContext();

  useEffect(() => {
    const tes = record.items?.bonus?.item_groups
      ?.map((v) => ({
        id: v,
        name: v,
      }))
      .sort((a, b) => {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    if (tes) setSelectedTargetItemGroup(tes);
  }, [setSelectedTargetItemGroup, record.items?.bonus?.item_groups]);

  return (
    <Autocomplete
      fullWidth
      multiple
      id="tags-standard"
      disableCloseOnSelect={true}
      options={props.option || []}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      value={props.selectedTargetItemGroup}
      style={{ marginBottom: "32px" }}
      onChange={(_, v) => {
        // onChange(v)
        props.setFirstRender(false);
        setSelectedTargetItemGroup(v);
        props.setSelectedTargetItemKey([]);
        setValue(`configs.dirty`, true, { shouldDirty: true });
      }}
      required={props.validate.isRequired}
      PaperComponent={({ children }) => (
        <Paper className={classes.test}>{children}</Paper>
      )}
      disabled={record.start < today || props.disabled}
      renderInput={(params) => (
        <MuiTextField
          {...params}
          variant="filled"
          label={props.label}
          placeholder={`select Item Group`}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

const ItemTargetKeyAutocomplete = ({
  setSelectedTargetItemKey,
  today,
  error,
  helperText,
  ...props
}) => {
  const classes = useStyles();

  const { setValue } = useFormContext();

  const record = useRecordContext();

  useEffect(() => {
    const tes = record.items?.bonus?.item_keys?.map((v) => ({
      id: v,
      name: v,
    }));
    if (tes) setSelectedTargetItemKey(tes);
  }, [setSelectedTargetItemKey, record.items?.bonus?.item_keys]);

  return (
    <Autocomplete
      fullWidth
      multiple
      id="tags-standard"
      disableCloseOnSelect={true}
      options={props.option || []}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      value={props.selectedTargetItemKey}
      style={{ marginBottom: "32px" }}
      onChange={(_, v) => {
        // onChange(v)
        setSelectedTargetItemKey(v);
        setValue(`configs.dirty`, true, { shouldDirty: true });
      }}
      required={props.validate.isRequired}
      PaperComponent={({ children }) => (
        <Paper className={classes.test}>{children}</Paper>
      )}
      disabled={record.start < today}
      renderInput={(params) => (
        <MuiTextField
          {...params}
          variant="filled"
          label={props.label}
          placeholder={`select Item Key`}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

const SpecSubCsvFile = ({
  openCsvDialog,
  handleCloseCsvDialog,
  uploadedCsv,
  setUploadedFileCsv,
  specificSubscriber,
  handleUploadCsv,
  fileCsv,
  setFileCsv,
  today,
}) => {
  const { getValues, setValue } = useFormContext();
  const start = getValues("start");
  return (
    <Dialog open={openCsvDialog} onClose={handleCloseCsvDialog}>
      <DialogTitle>CSV File</DialogTitle>
      <DialogContent dividers>
        <SimpleForm toolbar={<ToolbarCsvDialog />}>
          <Button
            startIcon={<DescriptionIcon />}
            onClick={uploadedCsv}
            label={
              specificSubscriber?.length
                ? "See Uploaded CSV"
                : "Download Master CSV"
            }
            variant="outlined"
          />
          <br />
          {specificSubscriber?.length ? (
            <DialogContentText>
              <ReactJson
                src={specificSubscriber || []}
                collapsed={true}
                enableClipboard={false}
                displayDataTypes={false}
                displayObjectSize={true}
                groupArraysAfterLength={10}
                name={false}
              />
              <br />
            </DialogContentText>
          ) : (
            ""
          )}
          {start < today ? (
            ""
          ) : (
            <FileInput
              source="files"
              options={{ multiple: false }}
              onChange={(e) => {
                setFileCsv(e);
                const filenameArray = e?.name.split(".");
                filenameArray?.pop();
                setUploadedFileCsv(filenameArray?.join("."));
              }}
            >
              <FileField source="src" title="title" />
            </FileInput>
          )}
        </SimpleForm>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseCsvDialog}>Close</Button>
        <Button
          onClick={() => {
            handleUploadCsv(setValue);
            setValue(`configs.dirty`, true, { shouldDirty: true });
          }}
          startIcon={<UploadFileIcon />}
          label="Upload"
          autoFocus
          disabled={!fileCsv}
        />
      </DialogActions>
    </Dialog>
  );
};

const alertInformation = (type:string) => {
  const MySwal = withReactContent(Swal);
  let promptMessage = ``;
  switch(type) {
    case "PROMOTION_FEATURES":
      promptMessage = `
      <p><strong>Add Bonus:</strong> This option is used to add a bonus to a promotion that has been set up.</p>
      <p><strong>Add Cashback:</strong> This option is used to configure cashback settings within a promotion.</p>
      `
      break;
    case "TARGET_PROMOTION":
      promptMessage = `
      <p><strong>1x/MSISDN:</strong> The promotion is applicable only once per MSISDN (mobile subscriber number) for a single product.</p>
      <p><strong>For New Subscribers Only:</strong> The promotion targets only new subscribers (customers who have never completed a successful transaction) and new target number that has never been transacted.</p>
      <p><strong>For Specific Subscribers:</strong> The promotion is targeted at specific subscriber numbers that are manually uploaded through a CSV file.</p>
      <p><strong>For Registered Subscribers:</strong> The promotion applies only to subscribers who are already registered.</p>
      <p><strong>For Ever Productive Subscribers:</strong> The promotion is for customers who have completed at least one SUCCESS transaction since the release of the M21 app. There is no minimum transaction amount required.</p>
      <p><strong>For Comeback Subscribers:</strong> The promotion targets customers who have been inactive for over 30 days and then become active again.</p>
      `
      break;
    case "PROMOTION_USAGE":
      promptMessage = `
      <p><strong>Max Usage per Subs.:</strong> The maximum number of times a promotion can be used by each subscriber.</p>
      <p><strong>Max Total Usage:</strong> The total maximum number of times the promotion can be used by all subscribers combined.</p>
      <p><strong>Value:</strong> The price of the product in HKD (Hong Kong Dollars).</p>
      `
      break;
  }
  ;

  MySwal.fire({
    target: document.getElementById("history-modal"),
    title: `Information Detail`,
    html: (
      <Box
        sx={{ textAlign: "left" }}
        dangerouslySetInnerHTML={{ __html: promptMessage }}
        id="boxmessage"></Box>
    ),
  });
};